import {
  SettlementExportLineDescriptionField,
  SettlementExportLineDescriptionFormat_Read,
  SettlementExportSide,
} from '@treadinc/horizon-api-spec';

export class SettlementExportLineDescriptionFormat {
  constructor(
    private _id: string,
    private _side: SettlementExportSide,
    private _fields: SettlementExportLineDescriptionField[],
  ) {}

  public static parse(proto: SettlementExportLineDescriptionFormat_Read) {
    return new SettlementExportLineDescriptionFormat(proto.id, proto.side, proto.fields);
  }

  public get id() {
    return this._id;
  }

  public get side() {
    return this._side;
  }

  public get fields() {
    return this._fields;
  }
}
